// extracted by mini-css-extract-plugin
export var alignCenter = "_al-d";
export var bannerShown = "_al-6";
export var buttonContent = "_al-0";
export var cardList = "_al-1";
export var centerContent = "_al-2";
export var chevron = "_al-3";
export var closePanelButton = "_al-k";
export var conversationContextContainer = "_al-l";
export var conversationDetailContainer = "_al-4";
export var detailWrapper = "_al-7";
export var dropdownButton = "_al-e";
export var dropdownTitle = "_al-9";
export var fullHeight = "_al-5";
export var hidden = "_al-a";
export var icon = "_al-b";
export var mergeSuggestionWrapper = "_al-m";
export var panel = "_al-i";
export var portalButtonsWrapper = "_al-c";
export var right = "_al-j";
export var tableSummaryContainer = "_al-8";
export var tableSummaryHeader = "_al-g";
export var threeDotsButton = "_al-f";
export var wide = "_al-h";